var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import Link from "core/Link";
import Button from "core/Button";
import Tooltip from "core/Tooltip";
import { Wrapper, ToolTipIcon } from "./styles";
import useStripePortalLink from "./useStripePortalLink";
var StripePortalLink = function (_a) {
    var _b = _a.client, client = _b === void 0 ? null : _b, _c = _a.showTooltip, showTooltip = _c === void 0 ? true : _c, _d = _a.redirectPath, redirectPath = _d === void 0 ? "" : _d, _e = _a.organizationId, organizationId = _e === void 0 ? null : _e, _f = _a.errorLabel, errorLabel = _f === void 0 ? "Failed to Load" : _f, _g = _a.renderAs, renderAs = _g === void 0 ? "link" : _g, children = _a.children, props = __rest(_a, ["client", "showTooltip", "redirectPath", "organizationId", "errorLabel", "renderAs", "children"]);
    var _h = useStripePortalLink({
        client: client,
        redirectPath: redirectPath,
        organizationId: organizationId,
    }), requestRedirect = _h.requestRedirect, isProcessing = _h.isProcessing, hasError = _h.hasError;
    var renderButton = function () {
        if (renderAs === "button") {
            return (_jsx(Button, __assign({}, props, { disabled: isProcessing, onClick: requestRedirect, children: hasError ? errorLabel : children })));
        }
        return (_jsx(Link, __assign({}, props, { isButton: true, disableVisitedStyle: true, isDisabled: isProcessing, onClick: requestRedirect, children: hasError ? errorLabel : children })));
    };
    // Only wrap in container when tooltip is shown
    if (showTooltip) {
        return (_jsxs(Wrapper, { children: [renderButton(), _jsx(Tooltip, { clickToOpen: true, message: _jsxs(_Fragment, { children: ["Noun Project partners with Stripe for simplified billing and PCI Level 1 security. We don't store payment information on our servers.", " ", _jsx("a", { href: "https://stripe.com/docs/security", target: "_blank", rel: "noreferrer", children: "Learn more" })] }), size: "large", children: _jsx(ToolTipIcon, {}) })] }));
    }
    // No wrapper needed when no tooltip
    return renderButton();
};
export default StripePortalLink;
